import { ImgHTMLAttributes } from 'react';

export function ResponsiveImage(props: ImgHTMLAttributes<HTMLImageElement> & { imageWidth?: number | number[] }) {
    const { src, imageWidth, sizes, ...rest } = props;
    if (src && imageWidth) {
        // Pass `sizes` (plus one `imageWidth` per breakpoint) when the slot is a
        // different CSS size at different widths. `sizes` is ignored alongside
        // the 2x/3x descriptors below, so that case switches to `w` descriptors
        // and lets the browser weigh viewport and DPR together — it picks before
        // first paint, so there's no JS breakpoint to hydrate and no second
        // request when the real breakpoint turns out not to be the SSR guess.
        const widths = Array.isArray(imageWidth) ? imageWidth : [imageWidth];
        const maxWidth = Math.max(...widths);
        if (sizes) {
            const candidates = widths
                .reduce<number[]>((all, width) => all.concat(width * 2, width * 3), [])
                .filter((dw, index, all) => all.indexOf(dw) === index)
                .sort((a, b) => a - b);
            // eslint-disable-next-line jsx-a11y/alt-text, @next/next/no-img-element
            return <img {...rest} sizes={sizes} src={`${src}?dw=${maxWidth * 2}`} srcSet={candidates.map((dw) => `${src}?dw=${dw} ${dw}w`).join(', ')} />;
        }
        // eslint-disable-next-line jsx-a11y/alt-text, @next/next/no-img-element
        return <img {...rest} src={`${src}?dw=${maxWidth * 2}`} srcSet={`${src}?dw=${maxWidth * 2} 2x, ${src}?dw=${maxWidth * 3} 3x`} />;
    }
    // eslint-disable-next-line jsx-a11y/alt-text, @next/next/no-img-element
    return <img src={src} {...rest} />;
}
